export default __webpack_public_path__ + "static/media/edit-3.1537cc4a.svg";